"use client";

import { Layout } from 'antd';
import styles from './WhyThat.module.scss';
import { ScrollReveal } from '@/shared/ui/ScrollReveal';
import { CheckIcon, XIcon } from '@/shared/constants/icon';
import { useTranslations } from 'next-intl';

const { Content } = Layout;

const negativeData = [
  {
    id: 1,
    title: "neg1",
  },
  {
    id: 2,
    title: "neg2",
  },
  {
    id: 3,
    title: "neg3",
  },
  {
    id: 4,
    title: "neg4",
  },
];


const positiveData = [
  {
    id: 1,
    title: "pos1",
  },
  {
    id: 2,
    title: "pos2",
  },
  {
    id: 3,
    title: "pos3",
  },
  {
    id: 4,
    title: "pos4",
  },
];

export const WhyThat = () => {
  const t = useTranslations("musicPlayer.whyThat");
  
  return (
    <Content className={styles.root}>
      <ScrollReveal>
        <h1>{t("title")}</h1>
      </ScrollReveal>

      <ScrollReveal className={styles.root_blocks}>
        <section className={styles.root_block}>
          <h2>
            <span className={styles.root_block_icon}
              style={{
                backgroundColor: 'var(--color-red)'
              }}
            >
              <XIcon color="var(--color-cream)" />
            </span>
            {t("without")}
          </h2>
          <div className={styles.root_block_items}>
            {negativeData.map((item) => (
              <p key={item.id} className={styles.root_block_item}>
                <span className={styles.root_block_item_icon}>
                  <XIcon color="var(--color-red)" />
                </span>
                {t(item.title)}
              </p>
            ))}
          </div>
        </section>
        <section className={styles.root_block}>
          <h2>
            <span className={styles.root_block_icon}
              style={{
                backgroundColor: 'var(--color-green)'
              }}
            >
              <CheckIcon color="var(--color-cream)" />
            </span>
            {t("with")}
          </h2>
          <div className={styles.root_block_items}>
            {positiveData.map((item) => (
              <p key={item.id} className={styles.root_block_item}>
                <span className={styles.root_block_item_icon}>
                  <CheckIcon color="var(--color-green)" />
                </span>
                {t(item.title)}
              </p>
            ))}
          </div>
        </section>
      </ScrollReveal>
    </Content>
  );
};
